export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const SET_PAGE_SIZE_GLOBAL = " SET_PAGE_SIZE_GLOBAL"

//-------------------------------APPROVAL-LIST------------------------------------------
export const SET_APPROVALS_PENDING = "SET_APPROVALS_PENDING";
export const SET_APPROVALS_LIST = "SET_APPROVALS_LIST";
export const SET_APPROVALS_LIST_COUNT = " SET_APPROVALS_LIST_COUNT"
export const SET_APPROVALS_FORM = " SET_APPROVALS_FORM"
export const APPROVAL_LIST_ERROR = " APPROVAL_LIST_ERROR"
export const APPROVAL_LIST_COUNT_ERROR = " APPROVAL_LIST_COUNT_ERROR"

//-------------------------------APPROVAL-ACTIONS---------------------------------------
export const SET_ACTION = "SET_ACTION";
export const SET_SELECTED_REQUEST_ID = "SET_SELECTED_REQUEST_ID";
export const OPEN_APPROVAL_ACTION_MODAL = "OPEN_APPROVAL_ACTION_MODAL";
export const CLOSE_APPROVAL_ACTION_MODAL = "CLOSE_APPROVAL_ACTION_MODAL";
export const SUBMIT_APPROVAL_ACTION_PENDING = "SUBMIT_APPROVAL_ACTION_PENDING";
export const SUBMIT_APPROVAL_ACTION_SUCCESS = "SUBMIT_APPROVAL_ACTION_SUCCESS";
export const SUBMIT_APPROVAL_ACTION_ERROR = "SUBMIT_APPROVAL_ACTION_ERROR";
export const CLEAR_SUBMIT_APPROVAL_ACTION_ERROR = "CLEAR_SUBMIT_APPROVAL_ACTION_ERROR";
